import { render, staticRenderFns } from "./Cumulative.vue?vue&type=template&id=2225a537&scoped=true"
import script from "./Cumulative.vue?vue&type=script&lang=js"
export * from "./Cumulative.vue?vue&type=script&lang=js"
import style0 from "./Cumulative.vue?vue&type=style&index=0&id=2225a537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225a537",
  null
  
)

export default component.exports